import { IUser } from '~/types/user-info-types'

export type ChatAiErrorMessageType = 'rate' | 'network' | 'unauthorized' | 'unavailable' | null

export enum ChatAiErrorType {
  Rate = 'rate',
  Network = 'network',
  Unauthorized = 'unauthorized',
  /** The Oracle could not answer safely (a service issue, never a judgement of the student). */
  Unavailable = 'unavailable',
}
export interface ChatAiMessageProps {
  avatarPngUrl: string | null
  text: string
  type: string
  image?: string
  nickname: string
  tutorChat?: boolean
  isReceived: boolean
  isHint?: boolean
  /** The turn ended before the answer finished: the text is partial. */
  isCutOff?: boolean
  /** The safety gate stopped this student message: it is shown dimmed, labelled as not sent. */
  isNotSent?: boolean
  /** The chat sits on a light background (the curriculum AI page), not the Oracle gradient. */
  isOnLight?: boolean
  dynamicProp?: boolean
  locale?: string
  onImageClick: (image: string) => void
}

export interface VideoPosterProps {
  href: string
  locale: string
  dynamic?: boolean
  onClick: () => void
}

export type ChatUserType = Pick<IUser, 'avatarPngUrl' | 'nickname'>
